<template>
  <section>
    <header
      style="position: fixed; top: -15px; padding: 15px 15px 15px 15px; left: 0; border-bottom: 1px solid white; width: 100% !important; z-index: 1;"
    >
      <h2 class="white-text onboard">{{ eventName }}</h2>
    </header>
    <section
      class="cont-fullwidth"
      style="overflow: hidden !important;padding-top: 70px;padding-bottom: 90px;"
    >
      <div class="row d-flex align-content-center">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="innerpadding-30 w-600" v-if="!teamDataLoading">
            <h2 class="mt-0 mb-1 blue-text onboard">
              <span v-if="team.teamName">{{ team.teamName }} Check-in</span>
            </h2>
            <h2 class="mt-0 pt-0 mb-2 onboard">
              Please wait here for your teammates to arrive before starting the
              game
            </h2>

            <ul class="onboarding team-members" v-if="team.teamMembers">
              <li
                v-for="(teamMember, index) in team.teamMembers"
                :key="'team-member-' + index"
                class="activeTeam"
              >
                <small class="onboarding">Player {{ index + 1 }}</small>
                <div class="playerTeam">{{ teamMember }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <nav id="wait-for-team">
      <button class="btn-black-form mb-2 w-600" type="button" @click="finished">
        Start Game
      </button>
    </nav>
  </section>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    eventName: String,
    code: { type: String, required: true },
    team_id: { type: String, required: true }
  },
  data: () => ({}),
  created() {
    document.body.classList.add('purple-bg')
  },
  computed: {
    ...mapState({
      game: state => state.game
    }),
    gameData() {
      return this.game.teamData?.gameData
    },
    team() {
      return this.game.teamData
    },
    teamDataLoading() {
      return this.game.teamData?.gameData === undefined
    }
  },
  methods: {
    finished() {
      this.$emit('finished')
    }
  }
}
</script>
